<template>
  <a-modal
    title="请查询用户进行切换"
    :width="450"
    :visible="visible"
    :closable="false"
    :maskClosable="false"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form>
      <a-form-item :labelCol="{ span: 4 }" :wrapperCol="{ span: 20 }" style="margin-bottom: 10px">
        <a-tooltip placement="topLeft">
          <template slot="title">
            <span>运维人员切换用户查看</span>
          </template>
          <a-avatar style="backgroundcolor: #87d068" icon="gold" />
        </a-tooltip>
        <a-select
          show-search
          :default-active-first-option="false"
          :show-arrow="false"
          :filter-option="false"
          :not-found-content="null"
          v-model="userId"
          @search="handleSearch"
          allowClear
          placeholder="请输入用户姓名"
          style="margin-left: 10px; width: 80%"
        >
          <a-icon slot="suffixIcon" type="gold" />
          <a-select-option v-for="d in userList" :value="d.id">
            {{ d.realname }} - {{ d.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { getAction } from '@/api/manage'
import { mapActions } from 'vuex'
import { resetRouter } from '@/router'

export default {
  name: 'UserSelect',
  data() {
    return {
      visible: false,
      userList: [],
      userId: '',
    }
  },
  methods: {
    ...mapActions(['ChangeUser']),
    show() {
      this.userList = []
      this.visible = true
    },
    handleOk() {
      this.ChangeUser(this.userId)
        .then((res) => {
          this.$notification.success({
            message: '切换用户',
            description: `用户切换成功`,
          })
          // this.$router.push({
          //   path: '/dashboard/analysis',
          // })
          resetRouter()
          this.$router.push({
            path: '/',
          })
          location.reload()
        })
        .catch((err) => {})
    },
    handleCancel() {
      this.visible = false
    },
    handleSearch(value) {
      this.fetchUserData(value)
    },
    handleChange(value) {
      this.userId = value
    },
    fetchUserData(value) {
      // this.userList = []
      getAction('/statistic/getUserList', { name: value }).then((res) => {
        this.userList = res.result
      })
    },
  },
}
</script>

<style scoped></style>
